import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Provider from './context';
import { AppService } from 'components/AppService';
import Bookshelf from 'components/Bookshelf';
import { BookStore } from 'components/BookStore';
import Placeholder from 'components/Placeholder';
import ReaderActivity from 'components/ReaderActivity';
import { Beforeunload } from 'components/Beforeunload';
import QrcodeLogin from 'components/Login/QrcodeLogin';
import AnswerInteractiveToolStudent from 'components/GroupInteractiveTool/StudentView';
import GroupInteractiveToolHistory from 'components/GroupInteractiveTool/History';
import BookForStudent from 'components/BookForStudent';
import { ReferenceBookStore } from 'components/BookStore/ReferenceBookStore';
import ReferenceBookshelf from 'components/Bookshelf/ReferenceBookShelf';
import ExamList from 'components/ExamList';
import ExamStudentList from 'components/ExamStudentList';

const HookedBrowserRouter = ({ children }) => (
  <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
    <Route>
      {(routeProps) => (
        <Provider router={routeProps}>
          {children}
        </Provider>
      )}
    </Route>
  </BrowserRouter>
);

const App = () => {
  return (
    <Beforeunload>
      <HookedBrowserRouter>
        <AppService />
        <Switch>
          <Route exact path='/examlist' component={ExamList} />
          <Route exact path='/examStudentList' component={ExamStudentList} />
          <Route exact path='/bookshelf' component={window.reference ? ReferenceBookshelf : Bookshelf} />
          <Route exact path='/bookstore' component={window.reference ? ReferenceBookStore : BookStore} />
          <Route exact path='/loading' component={Placeholder} />
          <Route exact path='/qrcodelogin' component={QrcodeLogin} />
          <Route exact path='/groupInteractiveToolHistory' component={GroupInteractiveToolHistory} />
          <Route exact path='/bookForStudent/:bookId' component={BookForStudent} />
          <Route exact path='/:bookId' component={ReaderActivity} />
          <Route exact path='/answerInteractiveTool/:QRCode' component={AnswerInteractiveToolStudent} />
          <Redirect path='*' to='/bookshelf' />
        </Switch>
      </HookedBrowserRouter>
    </Beforeunload>
  );
};

export default App;

